function TopBar() {
  return (
    <div className="top-bar" aria-label="Company service area">
      <div className="container top-bar__inner">
        <div className="top-bar__contacts" aria-label="Contact details">
          <span>(437) 435-7083</span>
          <span>contact@evonindustrial.com</span>
          <span>Serving Canada</span>
        </div>
        <div className="top-bar__social" aria-label="Social media placeholders">
          <span>f</span>
          <span>in</span>
        </div>
      </div>
    </div>
  );
}

export default TopBar;
